export const SkymilesConfigMocks = {
  COMMON: {
    APP_AUTH_CONFIG_JSON:
      '/content/dam/delta-applications/login/auth-config.json',
    BAGGAGE_BFF_BROWSER_TIMEOUT: '5000',
    BAGGAGE_BFF_SERVER_TIMEOUT: '1000',
    CLIENT_DEVICE_TYPE_URL: '/home/devicetype',
    DASHBOARD_BFF_URL: '/login/login/getDashBrdData',
    GET_CLOSEST_DELTA_AIRPORT_CODE:
      '/pref/geoLocationService/getClosestDeltaAirportCode',
    GET_PERSONALIZED_CONTENT_URL:
      'https://personalization-api-dev.delta.com/personalization-api/getPersonalizedContent',
    GET_PREDICTIVE_CITIES_URL: '/predictivetext/getPredictiveCities',
    GET_PREDICTIVE_RENTAL_CARS_URL: '/predictivetext/getPredictiveRentalCars',
    HEADER_FOOTER_AEM_URL: '/content/www/us/en.headerfooter.json',
    LOGIN_URL: '/login/loginPage',
    LOGOUT_URL: '/login/login/logout',
    ENABLE_PING_LOGOUT: 'true',
    PING_DOMAIN: 'https://signin-si.delta.com',
    LOG_OUT_URL: '/idp/startSLO.ping?TargetResource=',
    LOGOUT_TIMEOUT: '5000',
    MONO_COMMON_PE_BROWSER_TIMEOUT: '2000',
    MONO_COMMON_PE_SERVER_TIMEOUT: '1000',
    PERSONALIZATION_ENGINE_URL:
      'https://personalization-api-dev.delta.com/personalization-api/getMultiplePersonalizedContent',
    AIRLINE_CONTENT_AEM_URL: '/content/dam/delta-com/refdata/airlineNames.json'
  },
  SKYMILES: {
    SKYMILES_API_ACCOUNT_ACTIVITY:
      '/accountactivitysvc/accountActivity/recentActivity',
    SKYMILES_API_ECREDITS: '/payment/eDocuments/search',
    SKYMILES_API_MEMBERSHIP_CARD:
      '/skymilesdocsvc/skymilesDoc/getSkymileCardURL',
    SKYMILES_API_PROMOTIONS:
      'https://loyalty-api-dev.delta.com/loyaltyPromotions/v1/myPromotions?requestTypeCode=All&categoryTypeCode=Partners Only',
    SKYMILES_API_STATUS_TRACKER:
      'https://loyalty-api-si.delta.com/loyaltyProgram/v2/statusTracker/medallionStatus',
    SKYMILES_API_FUTURE_ACTIVITIES:
      'https://loyalty-api-si.delta.com/loyaltyProgram/v2/statusTracker/futureActivities',
    SKYMILES_API_STATUS_TRACKER_MULTI_REGION:
      'https://loyalty2-api-si.delta.com/loyaltyProgram/v2/statusTracker/medallionStatus',
    SKYMILES_API_FUTURE_ACTIVITIES_MULTI_REGION:
      'https://loyalty2-api-si.delta.com/loyaltyProgram/v2/statusTracker/futureActivities',
    SKYMILES_API_VOUCHERS: '/skymilesdocsvc/skymilesDoc/getVoucher',
    SKYMILES_AEM_AUTH_CONFIG:
      '/content/dam/delta-applications/nextgenskymiles/auth-config.json',
    SKYMILES_AEM_LANDING_PAGE_MEDALLION_BANNER:
      '/content/www/accountmanagement/nextgenskymiles/medallion-banner.skymilesdata.json',
    SKYMILES_AEM_LANDING_PAGE_MENU:
      '/content/www/accountmanagement/nextgenskymiles/side-navigation.skymilesdata.json',
    SKYMILES_AEM_LANDING_PAGE_FEATURE_FLAGS:
      '/content/www/accountmanagement/nextgenskymiles/landing-page-feature-flags.skymilesFeatureFlags.json',
    SKYMILES_AEM_LANDING_PAGE_ERROR_MESSAGES:
      '/content/www/accountmanagement/nextgenskymiles/landing-page-error-messages.skymilesdata.json',
    SKYMILES_AEM_PARTNERS_ERROR_MESSAGES:
      '/content/www/accountmanagement/nextgenskymiles/partners-error-messages.skymilesdata.json',
    SKYMILES_AEM_OVERVIEW_CONTENT:
      '/content/www/accountmanagement/nextgenskymiles/overview-content.skymilesdata.json',
    SKYMILES_AEM_OVERVIEW_MAIN_CONTENT:
      '/content/www/accountmanagement/nextgenskymiles/nextgen-overview.ngmyskymilesdata.json',
    SKYMILES_AEM_OVERVIEW_ERROR_MESSAGES:
      '/content/www/accountmanagement/nextgenskymiles/overview-error-messages.skymilesdata.json',
    SKYMILES_AEM_OVERVIEW_FEATURE_FLAGS:
      '/content/www/accountmanagement/nextgenskymiles/feature-flag.skymilesFeatureFlags.json',
    SKYMILES_AEM_OVERVIEW_WELCOME_TOUR:
      '/content/www/accountmanagement/nextgenskymiles/overview-welcome-tour.skymilesdata.json',
    SKYMILES_AEM_PROMOTIONS_CONTENT:
      '/content/www/accountmanagement/nextgenpromotions/promotions.promotiondata.json',
    SKYMILES_AEM_PROMOTIONS_ERROR_MESSAGES:
      '/content/www/accountmanagement/nextgenskymiles/promotions-error-message.skymilesdata.json',
    SKYMILES_AEM_PROMOTIONS_FEATURE_FLAGS:
      '/content/www/accountmanagement/nextgenskymiles/promotions-feature-flag.skymilesFeatureFlags.json',
    SKYMILES_API_PROMOTIONS_MAIN:
      'https://loyalty-api-si.delta.com/loyaltyPromotions/v1/myPromotions?requestTypeCode=All&categoryTypeCode=All',
    SKYMILES_API_PROMOTIONS_MAIN_V2:
      'https://loyalty-api-si.delta.com/loyaltyPromotions/v2/myPromotions?requestTypeCode=All&categoryTypeCode=All',
    SKYMILES_API_PROMOTIONS_ENROLL:
      'https://loyalty-api-si.delta.com/loyaltyPromotions/v1/enrollment?enrollmentMethodTypeCode=promotionCode&enrollmentCode=',
    SKYMILES_API_PROMOTIONS_DETAILS:
      'https://loyalty-api-si.delta.com/loyaltyPromotions/v1/mypromotions/rewards?promotionCode=',
    SKYMILES_API_PROMOTIONS_CONTENT: 'https://content-api-si.delta.com/graphql',
    SKYMILES_API_BUSINESS_TRAVELER_PROMOTIONS_ENROLL:
      'https://loyalty-api-si.delta.com/loyaltyPromotions/v1/enrollment?enrollmentMethodTypeCode=promotionCode&enrollmentCode=',
    SKYMILES_API_BUSINESS_TRAVELER_CUSTOMER_PROFILE:
      'https://customer-api-si.delta.com/profile/graphql',
    SKYMILES_API_BUSINESS_TRAVELER_PROMOTIONS_DETAILS:
      'https://loyalty-api-si.delta.com/loyaltyPromotions/v1/mypromotions/rewards',
    SKYMILES_API_BUSINESS_TRAVELER_ENROLL:
      'https://api2.loy-mgmt-si.aws.delta.com/loyaltyProgram/v1/biztravel/enrollment',
    SKYMILES_API_BUSINESS_TRAVELER_ELIGIBILITY:
      'https://api2.loy-mgmt-si.aws.delta.com/loyaltyProgram/v1/biztravel/eligibility',
    SKYMILES_API_BUSINESS_TRAVELER_CANCELLATION:
      'https://api2.loy-mgmt-si.aws.delta.com/loyaltyProgram/v1/biztravel/cancellation',
    SKYMILES_AEM_ACCOUNT_ACTIVITY_CONTENT:
      '/content/www/accountmanagement/nextgenskymiles/nextgen-account-activity.ngmyskymilesdata.json',
    SKYMILES_AEM_ACCOUNT_ACTIVITY_ERROR_MESSAGES:
      '/content/www/accountmanagement/nextgenskymiles/account-activity-error-message.skymilesdata.json',
    SKYMILES_AEM_ACCOUNT_ACTIVITY_FEATURE_FLAGS:
      '/content/www/accountmanagement/nextgenskymiles/accountactivityfflags.skymilesFeatureFlags.json',
    SKYMILES_API_ACCOUNT_ACTIVITY_CONTENT:
      'https://loyalty-api-si.delta.com/loyaltyActivity/v2/accountActivity?preferenceCategoryCode=A',
    SKYMILES_API_PARTNERS_PROMOTIONS:
      'https://loyalty-api-dev.delta.com/loyaltyPromotions/v1/myPromotions?requestTypeCode=All&categoryTypeCode=Partners Only',
    SKYMILES_API_EARNS_SUMMARY:
      'https://loyalty-api-si.delta.com/loyaltyProgram/v1/accountActivity/dashboard',
    SKYMILES_AEM_MERGE_DUPLICATE_ACCOUNTS_CONTENT:
      '/content/dam/delta-applications/nextgenskymiles/pages/merge-duplicate-accounts/merge-duplicate-accounts.json',
    SKYMILES_API_MERGE_DUPLICATE_ACCOUNTS_VALIDATE:
      'https://channels-si-east.chnl-svcg-si.pub.delta.com/acctMerge/validateAccounts',
    SKYMILES_API_MERGE_DUPLICATE_ACCOUNTS_REVIEW:
      'https://channels-si-east.chnl-svcg-si.pub.delta.com/acctMerge/confirmAcctMerge',
    SKYMILES_AEM_ROLLOVER_CONTENT:
      'https://dvl3.delta.com/content/www/accountmanagement/nextgenskymiles/mqm-rollover.ngmyskymilesdata.json',
    SKYMILES_AEM_ROLLOVER_FEATURE_FLAGS:
      'https://dvl3.delta.com/content/www/accountmanagement/nextgenskymiles/rollover-mqm-feature-flags.skymilesFeatureFlags.json',
    SKYMILES_AEM_ROLLOVER_ERROR_MESSAGES:
      'https://dvl3.delta.com/content/www/accountmanagement/nextgenskymiles/rollover-mqm-feature-flags.skymilesFeatureFlags.json',
    SKYMILES_AEM_BUSINESS_TRAVELER_OVERVIEW:
      'https://dvl3.delta.com/content/www/accountmanagement/businessTraveler/overview.dbtdata.json', // TODO - Update with actual url
    SKYMILES_AEM_BUSINESS_TRAVELER_FEATURE_FLAGS:
      'https://dvl3.delta.com/content/dam/delta-applications/loyalty-applications/feature-flag.dbt.json',
    SKYMILES_API_SKYCLUB_TRACKER:
      'https://amexvisitreport-api-dev.delta.com/visitSummary',
    SKYMILES_API_BUSINESS_TRAVELER_ENROLLMENT_DBTN:
      'https://api2.loy-mgmt-si.aws.delta.com/loyaltyProgram/v1/biztravel/enrollmentDBTN'
  },
  EDUCATIONAL_CONTENT: {
    SKYMILES_AEM_EDUCATIONAL_CONTENT:
      '/content/www/accountmanagement/nextgenskymiles/educational-modal.ngmyskymilesdata.json'
  },
  PROFILE_SELECTOR: {
    PROFILE_SELECTOR_AEM_URL:
      '/content/www/en_US/profile-Selector.loginmodalcf.json',
    SESS_CUSTOMER_EDP_DATA_URL: '/pref/prefsController/saveDetails'
  }
};
